import React from 'react'
import { Nav } from 'react-bootstrap'
import PropTypes from 'prop-types'
import navStyles from '@shared/components/commonNav/style.module.scss'
import CustomLink from '../customLink'
import { allRoutes } from '@shared-submodule/sm-constants/allRoutes'

const NavPills = ({ navPillsData, selectedPill, setSelectedPill }) => {
  return (
    <Nav className={`${navStyles.commonNav} ${navStyles.pillsNav} justify-content-start mt-sm-0 flex-nowrap text-nowrap overflow-auto`} variant="pills">
      {navPillsData.map((type) => {
        return (
          <>
            <Nav.Item className={`${navStyles.item}`}>
              <CustomLink href={allRoutes.cricketSeriesNew} prefetch={false}>
                <a className={`${selectedPill === type.sValue && navStyles.active} nav-link`}
                  onClick={(e) => {
                    e.preventDefault()
                    setSelectedPill(type.sValue)
                  }}
                >
                  {type.sLabel}
                </a>
              </CustomLink>
            </Nav.Item>
          </>
        )
      }
      )}
    </Nav>
  )
}

NavPills.propTypes = {
  navPillsData: PropTypes.array,
  selectedPill: PropTypes.string,
  setSelectedPill: PropTypes.func
}

export default NavPills
